/*eslint eqeqeq: "off"*/
/*eslint no-unused-vars: "off"*/
/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/
import Page from 'components/Page';
import { IndexColumn } from 'components/Table/Columns';
import useUsuario from 'hooks/useUsuario';
import moment from 'moment';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
} from 'reactstrap';
import { loginAsSuscriptor, logoutAsSuscriptor } from 'redux/actions/aLogin';
import { consumirServicioEncirptacion } from '../../api';
import Breadcrumcomponent from '../../components/BreadCrumbMex/BreadCrumb';
import { empresa } from '../../constants';
import { ambienteAplicacion, urlListadoCotizaciones } from '../../constants/urls';
import { scrollTop } from '../../utils/funciones';
import Loading from '../../wrappers/Loading';
import './styles.scss';

const ContainerListadoCotizaciones = () => {
  const [loading, setLoading] = useState(false);
  const refBuscador = useRef(null);
  const usuario = useUsuario();
  const history = useHistory();
  const [fetchedData, setFetchedData] = useState([]);
  const [leads, setLeads] = useState([]);
  const [ramos, setRamos] = useState([]);
  const [truncados, setTruncados] = useState([]);
  const dispatch = useDispatch();

  const { cliCodigoCore } = useSelector((state) => state.datosUsuarios.dataUsuario);

  const mapItemsTable = (items, ramos) => {
    return items.map((value, index) => {
      const date = moment(value.fecha);
      const hora = moment(value.fecha);
      const dateMoment =
        date.format('dddd DD [de] MMMM [de] yyyy, [a las ]').toString().toUpperCase() +
        hora.format('HH:mm:ss a');

      const ramo = ramos.find((item) => item.id === value.ramoNombre);

      return {
        ...value,
        fecha: dateMoment,
        ramo: {
          id: ramo?.id,
          nombre: ramo?.name,
        },
        '#': index + 1,
      };
    });
  };

  const fetchData = async () => {
    setLoading(true);
    const body = {
      ambiente: ambienteAplicacion,
      empresa: empresa,
      idUsuario: cliCodigoCore,
    };
    if (usuario?.isSuscriptor && usuario?.usu_tipo_usuario !== 'usu-suscriptor-sbs') {
      if (usuario?.sesionSuscriptor) {
        const { sesionSuscriptor } = usuario;
        body.idUsuario = sesionSuscriptor?.cliCodigoCore;
        dispatch(loginAsSuscriptor(sesionSuscriptor));
      } else {
        if (usuario?.usu_tipo_usuario !== "usu-suscriptor-casualty-contratistas" && usuario?.usu_tipo_usuario !== "usu-suscriptor-casualty-generales") {
          dispatch(logoutAsSuscriptor());
          return history.push("/");
        }    
      }
    }
    const response = await consumirServicioEncirptacion(urlListadoCotizaciones, body);
    if (response.transaccion) {
      setRamos(response.ramosfiltro);
      const result = mapItemsTable(response.leads, response.ramosfiltro);
      setFetchedData(result);
      setLeads(result);
    }
    scrollTop();
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
    scrollTop();
  }, []);

  const bodyVerDetalles = (row) => {
    let path = '';

    if (!row.urlCotizacion) {
      return null;
    }

    if (row.urlCorizacion) {
      path = row.urlCorizacion;
    } else {
      path = row.urlCotizacion;
    }

    if (path[0] !== '/') {
      path = `/${path}`;
    }

    return (
      <button className="btn btn-primary" onClick={() => history.push(path)}>
        Detalles Cotizacion
      </button>
    );
  };

  const onClickBuscar = () => {
    const text = refBuscador.current.value.toLowerCase();
    if (text === '') {
      setLeads(fetchedData);
      return;
    }

    const result = fetchedData.filter(
      (item) =>
        item.fecha.toLowerCase().includes(text) ||
        item.contNombre.toLowerCase().includes(text) ||
        item.ramoNombre.toLowerCase().includes(text) ||
        item.primaTotal.includes(text) ||
        item.idCarrito.includes(text)
    );

    setLeads(result);
  };

  const onChangeSelect = ({ target }) => {
    const { value } = target;

    if (value === '') {
      setLeads(fetchedData);
      return;
    }
    const result = fetchedData.filter((item) => item?.ramo?.id === value);

    setLeads(result);
  };

  useEffect(() => {
    var formatter = new Intl.NumberFormat('en-US', {
      currency: 'USD',
      maximumFractionDigits: 2,
    });
    const valoresTruncados = leads.map((item) => {
      if (item?.primaTotal && !isNaN(item?.primaTotal)) {
        const primaTotal = formatter.format(parseFloat(item?.primaTotal));
        return { ...item, primaTotal };
      } else {
        return item;
      }
    });

    setTruncados(valoresTruncados);
  }, [leads]);

  return (
    <Loading loading={loading} message="Cargando Listado de Cotizaciones...">
      <div className="cr-content ">
        <Page>
          <Breadcrumcomponent title="Listado de Cotizaciones" subtitle="Listado de Cotizaciones" />
          <Row className="mb-3 justify-content-center">
            <div className="col-lg-8">
              <InputGroup size="sm">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>Buscar texto:</InputGroupText>
                </InputGroupAddon>

                <input
                  type="text"
                  className="form-control"
                  ref={refBuscador}
                  onKeyUp={(e) => {
                    if (e.key === 'Enter') {
                      onClickBuscar();
                    }
                  }}
                />
                <InputGroupAddon addonType="prepend">
                  <button className="btn rounded-right btn-mex" onClick={onClickBuscar}>
                    BUSCAR
                  </button>
                </InputGroupAddon>
              </InputGroup>
            </div>
            <Col lg={4} md={12} sm={12} xs={12}>
              <FormGroup>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>Ramo</InputGroupText>
                  </InputGroupAddon>

                  <Input type="select" name="selectMulti" onChange={onChangeSelect}>
                    {ramos.map((ramo, index) => {
                      return (
                        <option key={index} id={ramo.id} value={ramo.id} className="op-mex">
                          {ramo.name}
                        </option>
                      );
                    })}
                  </Input>
                </InputGroup>
              </FormGroup>
            </Col>
          </Row>

          {fetchedData.length > 0 && (
            <Row>
              <div className="col-12">
                <DataTable
                  //value={leads}
                  value={truncados}
                  responsive
                  className="p-datatable-gridlines mb-5 p-datatable-sm"
                  rowHover
                  paginator
                  rows={10}
                  rowsPerPageOptions={[10, 25, 50]}
                  emptyMessage="No se han encontrado resultados"
                  resizableColumns
                  autoLayout
                  //currentPageReportTemplate="Visualizando {first} hasta {last} de {totalRecords} registros"
                  //paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                >
                  {IndexColumn()}
                  <Column field="fecha" header="Fecha" sortable style={{ width: '250px' }} />
                  <Column
                    field="idCarrito"
                    header="Fólio de cotización"
                    sortable
                    className="text-center"
                  />
                  <Column field="contNombre" header="Contratante" sortable />
                  <Column field="ramo.nombre" header="Ramo" sortable className="text-center" />
                  <Column
                    field="primaTotal"
                    header="Total"
                    sortable
                    style={{ width: '130px' }}
                    className="text-center"
                  />
                  <Column header="Detalles" body={bodyVerDetalles} style={{ width: '225px' }} />
                </DataTable>
              </div>
            </Row>
          )}

          {fetchedData.length === 0 && (
            <h1 className="text-center font-mex my-5">Sin Resultados</h1>
          )}
        </Page>
      </div>
    </Loading>
  );
};

export default ContainerListadoCotizaciones;
